import { render } from "./EnvironmentCircular.vue?vue&type=template&id=35e8c461&ts=true"
import script from "./EnvironmentCircular.vue?vue&type=script&lang=ts"
export * from "./EnvironmentCircular.vue?vue&type=script&lang=ts"

import "./EnvironmentCircular.vue?vue&type=style&index=0&id=35e8c461&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__